// extracted by mini-css-extract-plugin
export default {"container":"equipments_container__7YvOj","content":"equipments_content__9tAFq"};